module.exports = __webpack_public_path__ + "img/torilive.b18741ce.svg";